import { PBMLaboratoryIcon } from '@/components/icons/product/pbm-laboratory-icon';
import SquaredBox from '@/components/ui/squared-box';

export default function Header() {
  return (
    <SquaredBox.Header
      title="Programa de Laboratório"
      subtitle={
        <>
          Preços exclusivos de PBM
        </>
      }
      icon={<PBMLaboratoryIcon />}
      className="bg-[#E8F2FB]"
      titleStyle="text-accent"
    />
  );
}
